export const PERMISSION_LABELS: Record<string, string> = {
    admin: 'Admin',
    editMapStationsNotes: 'Edit Map',
    createEditEventInfo: 'Edit Events',
    viewWasteData: 'View Data',
    editWasteData: 'Edit Data',
    generateReports: 'Reports',
    editTodos: 'Edit Todos',
    completeTodos: 'Do Todos',
    viewInventory: 'View Inv.',
    manageInventory: 'Manage Inv.',
    editUsers: 'Edit Users',
};

export const PERMISSION_KEYS = [
    'admin',
    'editMapStationsNotes',
    'createEditEventInfo',
    'viewWasteData',
    'editWasteData',
    'generateReports',
    'editTodos',
    'completeTodos',
    'viewInventory',
    'manageInventory',
    'editUsers',
] as const;

export type PermissionKey = (typeof PERMISSION_KEYS)[number];
